// extracted by mini-css-extract-plugin
module.exports = {"fontPoppins":"RightPane_fontPoppins__17M7m","fontPoppinsLight":"RightPane_fontPoppinsLight__3_wIT","imgHardLight":"RightPane_imgHardLight__3hqP5"};